import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/App/App';
import { applyPreferencesToDocument } from '@/shared/utils/preferences-bootstrap/preferences-bootstrap.util';
import { readPreferencesFromStorage } from '@/shared/utils/preferences-storage/preferences-storage.util';
import '@/styles/globals.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container #root is missing from index.html');
}

/**
 * Theme, language and direction go onto `<html>` BEFORE React mounts.
 *
 * `index.html` ships `lang="ar" dir="rtl"` as the default, which is right for a
 * first visit but wrong for an operator who chose English or light mode. Doing
 * this in an effect instead means every page load starts in the wrong language
 * and the wrong theme for one frame — a flash that is far more noticeable in a
 * direction switch than in a colour one, because the entire layout jumps.
 *
 * The `./shared/i18n` import above is a side effect too: it registers the
 * `common`, `uiKit` and `permissions` catalogs before the first render can ask
 * for a string.
 */
applyPreferencesToDocument(readPreferencesFromStorage());

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
